import { useQuery } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next"
import { toast } from "react-toastify";
import { Alert, Col, Row } from "reactstrap";
import KYBService from "src/modules/3rd-party-management/apis/admin/KYBService";
import DriverHandler from "./drivers";

const DetailErrorMessages = {
    "insufficient_credit_kyb": "You don’t have enough {{creditsLabel}} to complete this action.",
    "data not found or fetch failed": "The company details could not be found. It may no longer be available or accessible.",
    "unknown": "An error occurred while fetching the company details. Please try again later."
};

const CompanyDetails = ({ t, id, supplierData, provider }) => {
    const handleFetchOrgDetails = useQuery({
        queryKey: [
            '3rd-party-management-kyb-get-organization-details',
            id
        ],
        queryFn: async () => {
            const service = KYBService.getInstance();

            return await service.getFetchedOrgDetails(
                id, 
                provider, 
                supplierData?.id
            );
        },
        cacheTime: 10,
        refetchOnWindowFocus: false,
        enabled: !!id,
        retry: 0,
        onError: ({ response }) => {
            toast(t(DetailErrorMessages[response?.data?.error] || DetailErrorMessages['unknown'], {
                creditsLabel: 'credits'
            }), {
                type: 'error'
            });
        }
    });

    if (handleFetchOrgDetails.isFetching) {
        return (
            <Row>
                <Col sm="12" className="mt-4 mb-4">
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '100px' }}></div>
                </Col>
                <Col sm="12" className="mb-4">
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '100px' }}></div>
                </Col>
                <Col sm="12" className="mb-4">
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '100px' }}></div>
                </Col>
                <Col sm="12" className="mb-4">
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '100px' }}></div>
                </Col>
                <Col sm="12" className="mb-4">
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '100px' }}></div>
                </Col>
            </Row>
        )
    }

    if (handleFetchOrgDetails.isError) {
        return (
            <Alert
                color="danger"
            >
                <p className="mb-0">
                    {t(
                        DetailErrorMessages[handleFetchOrgDetails.error?.response?.data?.error] || 
                        DetailErrorMessages['unknown'],
                        {
                            creditsLabel: 'credits'
                        }
                    )}
                </p>
            </Alert>
        )
    }

    const driverKey = handleFetchOrgDetails.data?.company?.source;

    return (
        <DriverHandler 
            driverKey={driverKey}
            detailsQuery={handleFetchOrgDetails}
            supplierData={supplierData}
        />
    );
}

export default withNamespaces()(
    CompanyDetails
);